<template>
  <v-combobox
    :data-test-chips="$attrs.name"
    v-if="type === 'combobox'"
    v-bind="{ ...$attrs, ...$props }"
    :menu-props="{ bottom: true, offsetY: true }"
    autocomplete="false"
    v-on="$listeners"
    @input="$emit('input', $event)"
  >
    <template v-slot:item="{ item }">
      <div :data-test-chips-value="item.name">
        {{ item.name }}
      </div>
    </template>
    <template v-slot:selection="data">
      <v-chip
        small
        :data-test-chip="data.item.name"
        color="primary"
        close
        @click:close="handleCloseChip(data)"
        close-icon="mdi-close-circle"
      >
        <template v-if="data.item.name">
          {{ data.item.name }}
        </template>

        <template v-else>
          {{ data.item }}
        </template>
      </v-chip>
    </template>
  </v-combobox>
  <v-select
    :menu-props="{ bottom: true, offsetY: true }"
    :data-test-chips="$attrs.name"
    v-else
    v-bind="{ ...$attrs, ...$props }"
    autocomplete="false"
    v-on="$listeners"
    @input="$emit('input', $event)"
  >
    <template v-slot:item="{ item }">
      <div :data-test-select-value="item.name">
        {{ item.name }}
      </div>
    </template>
    <template v-slot:selection="data">
      <v-chip
        small
        color="primary"
        close
        :data-test-chip="data.item.name"
        @click:close="handleCloseChip(data)"
        close-icon="mdi-close-circle"
      >
        <template v-if="data.item.name">
          {{ data.item.name }}
        </template>

        <template v-else>
          {{ data.item }}
        </template>
      </v-chip>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'SelectChips',
  props: {
    type: {
      type: String,
      default: 'combobox'
    }
  },
  setup(_, { emit }) {
    const handleCloseChip = data => {
      emit('drop-item', data.item?.id || data.item);
    };

    return {
      handleCloseChip
    };
  }
};
</script>
